import { render } from "./payment_method.vue?vue&type=template&id=588351d8"
import script from "./payment_method.vue?vue&type=script&lang=js"
export * from "./payment_method.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__